import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconShieldUp,
  IconRocket,
  IconBug,
  IconScale,
} from '@tabler/icons-react';

const cyberAuditFeatures: FeatureData[] = [
  {
    title: 'PME souhaitant de renforcer leur sécurité',
    description:
      'Identifiez et corrigez vos failles avant qu\'elles ne soient exploitées, pour protéger vos données et préserver votre réputation.',
    icon: <IconShieldUp size={24} />,
    key: 'auditCyber.features.pme',
  },
  {
    title: 'Entreprises dans des secteurs régulés',
    description:
      'Assurez-vous de respecter les normes réglementaires en vigueur avec un audit complet, garantissant la sécurité de vos processus métiers.',
    icon: <IconScale size={24} />,
    key: 'auditCyber.features.regulated',
  },
  {
    title: 'Startups technologiques innovantes',
    description:
      'Sécurisez votre croissance en identifiant les vulnérabilités de vos applications et infrastructures pour prévenir tout incident.',
    icon: <IconRocket size={24} />,
    key: 'auditCyber.features.startups',
  },
  {
    title: 'Entreprises victimes de cyberattaques',
    description:
      'Renforcez votre posture de sécurité après une cyberattaque avec un audit approfondi qui vous permettra de restaurer la confiance.',
    icon: <IconBug size={24} />,
    key: 'auditCyber.features.victims',
  },
];

export default cyberAuditFeatures; 